import { fetchCampaignCreatorsQuery } from 'api/queries/campaigns';
import { useGraphql } from 'utils/hooks/useGraphql';
import { User } from '../types';

type CampaignCreatorsResponse = {
  campaignCreators: User[];
};

export const useCampaignCreators = () => {
  const {
    data: { campaignCreators = [] } = {},
    isLoading,
    error,
  } = useGraphql<CampaignCreatorsResponse>(fetchCampaignCreatorsQuery);

  return { campaignCreators, isLoading, error };
};
